/**
 * Simplified DDS production-place status labels for display.
 * Maps raw EUDR deforestation probability statuses to:
 * - Zero/Negligible (green)
 * - Risk Detected (medium/high risk)
 */

const ZERO_NEGLIGIBLE_STATUSES = new Set([
    'Zero/Negligible Deforestation Probability',
    'Zero/Negligible Probability',
    'Compliant',
    'Very Low Deforestation Probability',
    'Very Low Probability',
  ])
  
  const RISK_DETECTED_STATUSES = new Set([
    'Medium Deforestation Probability',
    'Medium Probability',
    'High Deforestation Probability',
    'High Probability',
    'Very High Deforestation Probability',
    'Very High Probability',
    'Low Deforestation Probability',
    'Low Probability',
    'Non-compliant',
    'Non-Compliant',
    'Risk Detected',
  ])
  
  const RISK_DETECTED_BADGE_CLASS = 'red-button'
  
  export function getDdsSimplifiedStatus(status, $t) {
    if (!status || !$t) return null
  
    if (ZERO_NEGLIGIBLE_STATUSES.has(status)) {
      return { class: 'green-button', text: $t('deforestation.zeroOrNegligible') }
    }
  
    if (RISK_DETECTED_STATUSES.has(status)) {
      return { class: RISK_DETECTED_BADGE_CLASS, text: $t('deforestation.riskDetected') }
    }
  
    const s = String(status).toLowerCase()
    if (s.includes('zero') || s.includes('negligible') || s === 'compliant' || s.includes('very low')) {
      return { class: 'green-button', text: $t('deforestation.zeroOrNegligible') }
    }
    if (s.includes('medium') || s.includes('high') || s.includes('low deforestation') || s.includes('low probability')) {
      return { class: RISK_DETECTED_BADGE_CLASS, text: $t('deforestation.riskDetected') }
    }
    if (s.includes('risk detected')) {
      return { class: RISK_DETECTED_BADGE_CLASS, text: $t('deforestation.riskDetected') }
    }

  return null
}

/** True when EUDR assessment indicates deforestation risk (simplified red / Risk Detected side). */
export function isEudrRiskDetectedStatus(status) {
  if (!status) return false

  if (ZERO_NEGLIGIBLE_STATUSES.has(status)) return false
  if (RISK_DETECTED_STATUSES.has(status)) return true

  const s = String(status).toLowerCase()
  if (s.includes('manually mitigated')) return false
  if (s.includes('zero') || s.includes('negligible') || s === 'compliant' || s.includes('very low')) {
    return false
  }
  if (
    s.includes('medium')
    || s.includes('high')
    || s.includes('low deforestation')
    || s.includes('low probability')
    || s.includes('non-compliant')
    || s.includes('risk detected')
  ) {
    return true
  }

  return false
}

export function isEudrManuallyMitigatedStatus(status) {
  if (!status) return false
  const s = String(status).toLowerCase()
  return s.includes('manually mitigated') || s.includes('manually_mitigated')
}

export function isEudrErrorStatus(status) {
  if (!status) return false
  const s = String(status).toLowerCase()
  return (
    s.includes('error')
    || s.includes('invalid')
    || s.includes('not available')
    || s.includes('unknown')
  )
}
  